import { ViewStateType, ViewType } from "../Models/AppModel.js";
import { HistoryManager } from "./HistoryManager.js";
export class HistoryController {
    get hasUndo() { return this.currentHistory.hasUndo; }
    get hasRedo() { return this.currentHistory.hasRedo; }
    get currentHistory() {
        return this._appModel.activeView === ViewType.AP ? this.AP : this.LT;
    }
    constructor(_main) {
        this._main = _main;
        this.AP = new HistoryManager();
        this.LT = new HistoryManager();
    }
    setModels(bindedModel, appModel) {
        this._bindedModel = bindedModel;
        this._appModel = appModel;
        this.AP.setModels(bindedModel, appModel);
        this.LT.setModels(bindedModel, appModel);
    }
    startTracking(viewType, target) {
        if (viewType === ViewType.AP) {
            this.AP.startTracking(target);
        }
        else if (viewType === ViewType.LT) {
            this.LT.startTracking(target);
        }
        else {
            throw new Error("Invalid view type");
        }
    }
    detectChanges(viewType, switchViewport = true) {
        if (viewType === ViewType.AP) {
            this.AP.detectChanges();
        }
        else if (viewType === ViewType.LT) {
            this.LT.detectChanges();
        }
        else {
            throw new Error("Invalid view type");
        }
        if (switchViewport && this._appModel.activeViewState === ViewStateType.multiple) {
            if (this._appModel.activeView !== viewType) {
                this._main.multiviewRenderer.activeViewport = this._main.multiviewRenderer.viewsports[viewType];
            }
        }
    }
    undo() {
        this.currentHistory.undo();
    }
    redo() {
        this.currentHistory.redo();
    }
    clear(viewType) {
        if (viewType === undefined) {
            this.AP.clear();
            this.LT.clear();
            return;
        }
        if (viewType === ViewType.AP) {
            this.AP.clear();
        }
        else if (viewType === ViewType.LT) {
            this.LT.clear();
        }
        else {
            throw new Error("Invalid view type");
        }
    }
}
//# sourceMappingURL=HistoryController.js.map